import { createContext } from 'react';

export const CookiesContext = createContext(undefined);
